import Autocomplete from '@mui/material/Autocomplete';
import {styled} from '@mui/material/styles';

export const CAutocomplete = styled(Autocomplete)(
  (/* { theme } */) => ({
  }),
);
